import { createSlice } from '@reduxjs/toolkit'

function readHandwareIndex() {
  const index = Number.parseInt(localStorage.getItem("handwareIndex"), 10);
  return Number.isFinite(index) && index >= 0 ? index : 0;
}

export const handwareSlice = createSlice({
  name: 'handware',
  initialState: {
    value: {
      index: readHandwareIndex()
    },
  },
  reducers: {
    changeIndex: (state, action) => {
      const { index } = action.payload
      state.value = {
        index: index
      }
    },
  },
})

export const { changeIndex } = handwareSlice.actions

export default handwareSlice.reducer